import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import MobileBottomBar from "./MobileBottomBar";
import AccessibilityWidget from "./AccessibilityWidget";
import TrackingScripts from "./TrackingScripts";
import DoctolibWidget from "./DoctolibWidget";
import { useLang } from "../../lib/i18n";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // poll until the anchor target exists (page sections load async)
      const start = Date.now();
      const tryScroll = () => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (Date.now() - start < 3000) {
          setTimeout(tryScroll, 150);
        }
      };
      setTimeout(tryScroll, 100);
      return;
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

export default function PublicLayout() {
  const [cookieSignal, setCookieSignal] = useState(0);
  const { lang } = useLang();
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Header />
      <ScrollManager />
      <main id="maincontent" className="flex-1 pt-[72px] md:pt-[80px] lg:pt-[88px] pb-24 md:pb-0" data-testid="public-main">
        <Outlet />
      </main>
      <Footer onOpenCookieSettings={() => setCookieSignal((v) => v + 1)} />
      <CookieBanner openSignal={cookieSignal} />
      <MobileBottomBar />
      <AccessibilityWidget />
      <DoctolibWidget />
      <TrackingScripts />
    </div>
  );
}
